<template>
    <layout-internal-container>
        <!-- <a-modal
            v-model:open="isNotifProgressOpen"
            centered
        >
            <template #title>
                <div class="flex flex-col gap-2">
                    <span class="text-lg font-semibold flex flex-row gap-2 items-center">
                        <IconBellRingingFilled class="text-primary" />

                        Reminder
                    </span>

                    <span class="text-sm text-gray-600 font-normal pt-3 pb-2">Your course <span class="font-semibold">{{ lastProgress.course_title }}</span> is waiting for you! Now's the perfect time to jump back in and keep learning.</span>
                </div>
            </template>

            <template #footer>
                <div class="border-t-2 w-full flex justify-end pt-4 gap-2">
                    <a-button class="flex flex-row gap-2 items-center justify-center" type="primary" size="large" @click="$router.push('/Course/Learning/'+lastProgress.course_slug)">
                        Click Here
                    </a-button>
                </div>
            </template>
        </a-modal> -->

        <div class="w-full flex flex-col gap-12">
            <div class="flex-col gap-4" :class="progressLoaded">
                <span class="font-medium text-light">Please complete these steps before continuing: </span>

                <div class="flex flex-row items-center gap-4">
                    <div class="flex flex-row items-center gap-4">
                        <a-progress :size="80" type="circle" :percent="parseFloat(accountCheck.percentage.toFixed(1))" strokeColor="#0a543f" trailColor="#3e8b174D" class="m-0" :format="percent => `${accountCheck.total_my_progress} of ${accountCheck.total_progress}`" />
                        <!-- <div class="cursor-pointer flex flex-row items-center gap-4" @click="redirectAccountVerification">
                            <span class="text-md text-gray-600 gap-1 w-7/12 capitalize">
                                {{ accountCheck.next_action_name }}
                            </span>

                            <IconExternalLink class="text-primary text-sm"  />
                        </div> -->
                        <ol class="flex flex-col gap-2 list-none">
                            <li v-for="(item, index) in progress" :key="index">
                                <div v-if="accountCheck.detail[index]" class="flex flex-row items-center justify-between gap-4">
                                    <span class="font-light text-light">
                                        {{ item }}
                                    </span>
                                    
                                    <IconCircleCheckFilled class="text-primary" />
                                </div>

                                <div v-else class="flex flex-row items-center justify-between gap-4 cursor-pointer" @click="redirectAccountVerification(index)">
                                    <span class="font-bold text-primary flex flex-row items-center gap-2">
                                        {{ item }}
                                        <IconExternalLink class="text-primary text-sm"  />
                                    </span>
                                
                                    <IconAlertCircleFilled class="text-yellow-500"/>                                    
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

            
            <div class="flex flex-col gap-4">
                <div class="flex flex-row items-center justify-between">
                    <span class="font-medium text-light">Open Program</span>
                    <a-button @click="$router.push('/Internal/Program')" type="text"
                        class="text-primary flex flex-row justify-center items-center gap-2">
                        <span class="font-medium">Explore New Program</span>
                        <IconArrowRight :size="18" />
                    </a-button>
                </div>
                <div class="w-full">
                    <div v-if="(typeof programs == 'object' || typeof programs == 'array') && programs?.length > 0" class="gap-4 grid sm:grid-cols-2 xl:grid-cols-3">
                        <card-program v-for="item in programs" :enrolled="['Enrolled', 'Completed'].includes(item.isEnrolled)" :statusEnrolled="item.isEnrolled" :key="item.id" :name="item.title"
                            :tag="'btn-apply-dashboard-'+item.slug" 
                            :id="item.id"  :slug="item.slug" :image="item.photo" :type="item.type" :description="item?.short_desc"
                            :status="item.status" :date="moment(item.start_date).format('MMM DD, YYYY')" :batch="item.batch" :isOpen="item.isOpen" />
                    </div>
                    
                    <div v-else>
                        <p class="ms-4 mt-10 text-center">{{ typeof programs == 'string' ? programs : 'Open Program is Not Available' }}</p>
                    </div>
                </div>
            </div>
            
            <div class="flex flex-col gap-4">
                <div class="flex flex-row items-center justify-between">
                    <span class="font-medium text-light">Free Course Access</span>
                    <a-button @click="$router.push('/Internal/Course')" type="text"
                        class="text-primary flex flex-row justify-center items-center gap-2">
                        <span class="font-medium">Explore New Course</span>
                        <IconArrowRight :size="18" />
                    </a-button>
                </div>
                <div class="w-full">
                    <div v-if="(typeof courses == 'object' || typeof programs == 'array') && courses?.length > 0" class="gap-4 grid sm:grid-cols-2 xl:grid-cols-3">
                        <card-course class="md:min-w-[15rem] lg:min-w-[20rem]" v-for="item in courses" :key="item.id" 
                            :title="item.title" 
                            :duration="item.duration"
                            :rating="parseFloat(item.rating)" 
                            :image="item.photo" 
                            :enroll="item.total_reviews" 
                            :lesson="item.total_lessons"
                            :completed="item.total_completed"
                            :finished="item.finished_percentage"
                            :id="item.id" 
                            :slug="item.slug" 
                            :featured="item.featured"
                            :category="item.category" 
                            :speakerName="item.speaker_name"
                            :speakerPhoto="item.speaker_photo"
                            :isFree="true"
                            :enrolled="item.isEnrolled"
                        />
                    </div>
                    <div v-else>
                        <p class="ms-4 mt-10 text-center">{{ typeof courses == 'string' ? courses : 'Free Courses is Not Available' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </layout-internal-container>
</template>
  
<script setup>
import axios from "@/plugins/axios";
import { onMounted, ref } from 'vue'
import DummyCourse from '../../assets/Dummy/course.js'
import DummyPrograms from '../../assets/Dummy/program.js'
import { IconSearch, IconSortDescending, IconCategory2, IconChartDonut, IconCalendarMonth, IconTrophy, IconAlarm, IconHourglassEmpty, IconCertificate2, IconRotateClockwise2, IconArrowRight, IconExternalLink, IconCircleCheckFilled, IconXboxXFilled, IconAlertCircleFilled, IconBellRingingFilled } from '@tabler/icons-vue'
import { useRouter } from "vue-router";
import moment from "moment";


const tab = ref('All')
const progressLoaded = ref('hidden')
const courses = ref('')
const programs = ref('')
const lastProgress = ref([])

const isNotifProgressOpen = ref(false)

const router = useRouter();

const accountCheck = ref({
    "total_progress": 0,
    "total_my_progress": 0,
    "percentage": 0,
    "detail": {
        // "isWAVerif": 0,
        "isProfileComplete": 0,
        "isExistBusinessPerformance": 0,
        // "isCompletedCourse": 0,
    },
})


const progress = {
    // 'isWAVerif': '1. Verify Your WhatsApp Number',
    // 'isWAVerif': '1. Verify Your WhatsApp Number',
    'isProfileComplete': '1. Complete Your Profile Information',
    'isExistBusinessPerformance': '2. Complete the Latest Business Performance',
    // 'isCompletedCourse': '2. Complete "Introduction to Social Enterprise" Course',
}

const accountCompleteProgress = async () => {
    try {
        const response = await axios.get('check-account')

        accountCheck.value = response.data
        
        if (accountCheck.value.percentage < 100) {
            progressLoaded.value = 'flex'   
        }

    } catch (error) {
        console.error('Error fetching check account: ' ,error)
    }
}

const redirectAccountVerification = (index) => {
    switch (index) {
        // case 'isWAVerif':
        //     router.push('/Internal/Account')
        //     break;
        case 'isProfileComplete':
            router.push('/Internal/Account')
            break;
        case 'isExistBusinessPerformance':
            router.push('/Internal/Performance')
            break;
        // case 'isCompletedCourse':
        //     const uri = accountCheck.value.isEnrolled == 'Apply' ? 'Detail/' : 'Learning/';
            
        //     router.push('/Course/'+uri+accountCheck.value.course_id)

        //     break;    
    }
}

// const fetchRecents = async () => {
//     try {
//         const response = await axios.get('dashboard')

//         programs.value = response.data.recent_programs
//         courses.value = response.data.recent_courses
//     } catch (error) {
//         console.error('Error fetching recents:', error)
//     }
// }

const fetchPrograms = async () => {
    try {
        const response = await axios.get('open-programs')
        programs.value = response.data
    } catch (error) {
        console.error('Error fetching programs:', error)
    }
}

const fetchCourses = async () => {
    try {
        const response = await axios.get('featured-courses')

        courses.value = response.data
    } catch (error) {
        console.error('Error fetching courses:', error)
    }
}

const fetchLastProgress = async () => {
    try {
        const response = await axios.get('last-progress')

        lastProgress.value = response.data

        if (lastProgress.value.status == 'active' && sessionStorage.getItem('popUpSession') == 'true') {
            isNotifProgressOpen.value = true
            sessionStorage.removeItem('popUpSession')
        }
    } catch (error) {
        console.error('Error fetching last progress:', error)
    }
}

onMounted(() => {
    accountCompleteProgress()
    fetchPrograms()
    fetchCourses()
    fetchLastProgress()
})

</script>
  